import { makeDocumentMockData } from '../../modules/documentMockDataFactory'
import type { ILocationDocument } from '~/types/document/models'

export const {
  getDocumentListData: getLocationDocumentListData,
  getDocumentDataById: getLocationDocumentDataById,
  getDocumentListDataByParentId: getLocationDocumentListDataByLocationId,
} = makeDocumentMockData<ILocationDocument>({
  entityName: 'location',
  storageKeyPrefix: 'location',
})
